import script from "./jsjOrderList.vue?vue&type=script&setup=true&lang=js"
export * from "./jsjOrderList.vue?vue&type=script&setup=true&lang=js"

import "./jsjOrderList.vue?vue&type=style&index=0&id=66897593&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66897593"]])

export default __exports__